export var MPASubmitAction;
(function (MPASubmitAction) {
    MPASubmitAction["MPA_SUBMIT_ACTION_UNSPECIFIED"] = "MPA_SUBMIT_ACTION_UNSPECIFIED";
    MPASubmitAction["MPA_SUBMIT_ACTION_CONFIRM"] = "CONFIRM";
    MPASubmitAction["MPA_SUBMIT_ACTION_DISCARD"] = "DISCARD";
})(MPASubmitAction || (MPASubmitAction = {}));
